import StandardRestError from './Standard'

class InvitationMismatchError extends StandardRestError {
  static CODE = 'INVITATION_MISMATCH'

  constructor(
    message: string = 'Invitation mismatch',
    status = 410,
    body = {},
  ) {
    super(message)
    this.status = status
    this.body = body
  }
}

export default InvitationMismatchError
